module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/zight-logomark-600-600-aff06833f66faf1b293aa12cb1b92ae3.svg";